module.exports = __webpack_public_path__ + "img/ic_20_download_white.4b698ed5.svg";